import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { PropertySupplementState } from '../../../../../../types/properties/propertyTypes';
import DotIcon from '../../../../../components/DotIcon';
import Menu from '../../../../components/Menu';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Icon from '../../../../../../muiComponents/Icon';
import {
    getSupplierTaxCalculationRuleTypeSubTypes,
    supplierTaxCalculationRuleTypeFrequencyIcons,
    supplierTaxCalculationRuleTypeSubjectIcons,
    supplierTaxCalculationTypesIcons,
    TAX_DATE_TAG_COLOR,
    UnknownOptionIcons,
} from '../../../../../../utils/taxes/taxesListUtils';
import {
    categorizePeriod,
    formatDate,
    isDateless,
} from '../../../../../../utils/formatDates';
import Tag from '../../../../../../muiComponents/Tag';
import routes from '../../../../../../utils/commonVariables/routes';
import encodeBase64 from '../../../../../../utils/encodeBase64';

interface PropertySupplementRowProps {
    supplement: PropertySupplementState;
}
const PropertySupplementRow = ({ supplement }: PropertySupplementRowProps) => {
    const translate = useTranslate();

    const supplierTaxCalculationTypeIcon =
        supplierTaxCalculationTypesIcons[
            supplement.taxCalculationTypeKey as keyof typeof supplierTaxCalculationTypesIcons
        ];

    const supplierTaxCalculationRuleTypeSubIcons =
        getSupplierTaxCalculationRuleTypeSubTypes(
            supplement.taxCalculationRuleTypeKey
        );

    const supplierTaxCalculationRuleTypeSubjectIcon =
        supplierTaxCalculationRuleTypeSubIcons.subject
            ? supplierTaxCalculationRuleTypeSubjectIcons[
                  supplierTaxCalculationRuleTypeSubIcons.subject as keyof typeof supplierTaxCalculationRuleTypeSubjectIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_SUBJECT_TYPE;

    const supplierTaxCalculationRuleTypeFrequencyIcon =
        supplierTaxCalculationRuleTypeSubIcons.frequency
            ? supplierTaxCalculationRuleTypeFrequencyIcons[
                  supplierTaxCalculationRuleTypeSubIcons.frequency as keyof typeof supplierTaxCalculationRuleTypeFrequencyIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_FREQUENCY_TYPE;
    const isDatelessTax =
        isDateless(supplement.fromDate) && isDateless(supplement.toDate);
    const tagText = categorizePeriod(supplement.fromDate, supplement.toDate);

    return (
        <TableRow key={supplement.id}>
            <TableCell>
                <div className='flex-center'>
                    <DotIcon truthy={supplement.enabled} />
                </div>
            </TableCell>
            <TableCell>{supplement.name}</TableCell>
            <TableCell>{supplement.room}</TableCell>
            <TableCell>{supplement.mealPlan}</TableCell>
            <TableCell>{supplement.ratePlan}</TableCell>
            <TableCell>
                <div className='flex gap-10 '>
                    <Tooltip
                        title={`${translate('calculation_type')}: ${
                            supplement.taxCalculationType || ''
                        }`}
                    >
                        <span className='flex gap-5 flex-align-center'>
                            <Icon iconName={supplierTaxCalculationTypeIcon} />
                        </span>
                    </Tooltip>
                    <Tooltip
                        title={`${translate('applies_by')}: ${
                            supplierTaxCalculationRuleTypeSubIcons.subject || ''
                        }`}
                    >
                        <span className='flex gap-5 flex-align-center'>
                            <Icon
                                iconName={
                                    supplierTaxCalculationRuleTypeSubjectIcon
                                }
                            />
                        </span>
                    </Tooltip>
                    <Tooltip
                        title={`${translate('frequency')}: ${
                            supplierTaxCalculationRuleTypeSubIcons.frequency ||
                            ''
                        }`}
                    >
                        <span className='flex gap-5 flex-align-center'>
                            <Icon
                                iconName={
                                    supplierTaxCalculationRuleTypeFrequencyIcon
                                }
                            />
                        </span>
                    </Tooltip>
                </div>
            </TableCell>
            <TableCell>
                {!isDatelessTax ? (
                    <div
                        className='flex-column flex-align-end gap-10 height100perc flex-between'
                        style={{ minWidth: 170 }}
                    >
                        {formatDate(supplement.fromDate)} -{' '}
                        {formatDate(supplement.toDate)}
                        <Tag
                            text={tagText}
                            color={TAX_DATE_TAG_COLOR[tagText]}
                        />
                    </div>
                ) : (
                    ''
                )}
            </TableCell>
            <TableCell>
                <Menu
                    menuItems={[
                        {
                            text: 'go_to_supplement_detail',
                            icon: 'OpenInNew',
                            onClick: () => {
                                const route = `${routes.landingPrivate}${
                                    routes.supplements
                                }?id=${encodeBase64(supplement.id)}`;
                                window.open(route, route);
                            },
                        },
                    ]}
                />
            </TableCell>
        </TableRow>
    );
};

export default PropertySupplementRow;
